import { h } from 'vue';
import { Avatar } from 'ant-design-vue';

/**
 * Renders an avatar with the specified background color
 * @param {string} color - The background color for the avatar
 * @returns {VNode|null} - Vue virtual DOM node for the avatar or null if no color provided
 */
export function renderAvatar(color) {
  return color ? h(Avatar, { style: `background-color: ${color}` }) : null;
}
